import { render, staticRenderFns } from "./areaAdminProductList.vue?vue&type=template&id=d1ac85d4&scoped=true"
import script from "./areaAdminProductList.vue?vue&type=script&lang=js"
export * from "./areaAdminProductList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1ac85d4",
  null
  
)

export default component.exports